import React from "react";
import textConfig from "../utils/text";

/**
 * Frame 12
 * @param props
 */
export default function Frame12(props: any) {
	let {  Svg, svgProps, children, viewBox, backgroundColor, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1083 1637">
		<defs><clipPath id="myClip"><rect width={1000} height={1000} rx={30}/></clipPath></defs>
		<g>
			<path fill={backgroundColor} d="M966.489,990.552H692.18a34.889,34.889,0,0,0-25.265,10.828L505.7,1162.6a12.031,12.031,0,0,1-16.844,0L327.637,1001.38a34.89,34.89,0,0,0-25.265-10.828H28.062A24.062,24.062,0,0,1,4,966.489V28.062A24.062,24.062,0,0,1,28.062,4H966.489a24.062,24.062,0,0,1,24.062,24.062V966.489A24.062,24.062,0,0,1,966.489,990.552Z" transform="translate(44.124 44.124)" />
			<path fill={frameBody} d="M1043 1324H40C17.9086 1324 0 1341.91 0 1364V1597C0 1619.09 17.9086 1637 40 1637H1043C1065.09 1637 1083 1619.09 1083 1597V1364C1083 1341.91 1065.09 1324 1043 1324Z"/>
			<path fill={frameBody} fill-rule="evenodd" clip-rule="evenodd" d="M1034.68 0C1047.44 0 1059.68 5.0698 1068.71 14.0947C1077.73 23.1197 1082.8 35.3607 1082.8 48.124V1034.68C1082.8 1047.44 1077.73 1059.68 1068.71 1068.71C1059.68 1077.73 1047.44 1082.8 1034.68 1082.8H743.523C737.176 1082.89 731.121 1085.49 726.679 1090.02L558.244 1258.46C556.103 1260.79 553.5 1262.65 550.601 1263.93C547.701 1265.2 544.568 1265.86 541.4 1265.86C538.233 1265.86 535.101 1265.2 532.201 1263.93C529.302 1262.65 526.698 1260.79 524.557 1258.46L356.121 1090.02C351.679 1085.49 345.624 1082.89 339.277 1082.8H48.124C35.3607 1082.8 23.1197 1077.73 14.0947 1068.71C5.0698 1059.68 0 1047.44 0 1034.68V48.124C0 35.3607 5.06973 23.1197 14.0947 14.0947C23.1197 5.06973 35.3607 0 48.124 0H1034.68ZM63 41C51.9543 41 43 49.9543 43 61V1021C43 1031.87 51.6765 1040.72 62.4834 1040.99L63 1041H366.526C368.411 1042.32 370.165 1043.83 371.761 1045.5L532.98 1206.72C535.229 1208.93 538.253 1210.16 541.402 1210.16C544.552 1210.16 547.575 1208.93 549.824 1206.72L711.039 1045.5C712.634 1043.83 714.389 1042.32 716.273 1041H1023C1034.05 1041 1043 1032.05 1043 1021V61C1043 49.9543 1034.05 41 1023 41H63Z"/>
		</g>
		<g transform={"translate(43 41)"}>
			<g clipPath="url(#myClip)">{children}</g>
		</g>
		<g transform={"translate(43,1382) scale(1)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs><clipPath id="myClip"><path d={path}/></clipPath></defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}